module.exports = __webpack_public_path__ + "static/blog-07-5e34f955dd6c877f73e00d2489ee33af.jpg";